import { withPrefix } from 'gatsby';
import React from 'react'
import Slider from 'react-slick'

const sliderInfoText = [
  {
    keyId: "slide-1",
    first: true,
    gtmOption: "Registrate al programa",
    text: (
      <h2>
        <span>AhorroYa! </span>es el programa
        <br /> que te permite ahorrar <br />
        con tus consumos
      </h2>
    ),
  },
]

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 100,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  cssEase: 'linear',
  dotsClass: 'ahorroYa-banner-button__bar',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}

const SliderInfo = ({ scrollToSection, AhorroYaBannerBtn }) => {
  return (
    <Slider {...settings}>
        {sliderInfoText.map((element) => (
          <div key={element.keyId} className={element.first ? 'ahorroYa-banner__item' : 'ahorroYa-banner__item ahorroYa-banner__item--promo'}>
            <div className="ahorroYa-banner__content">
              {element.text}

              <div onClick={() => AhorroYaBannerBtn(element.gtmOption)}>
                <button
                  className="ahorroYa__button ahorroYa-banner__button"
                  onClick={() => scrollToSection('ahorroYa-register-section')}
                >
                  <div className="ahorroYa-banner__button-container">
                    <span className="c-gray--4">Regístrate al programa</span>
                    <img
                      src={withPrefix('/images/prima-productos/black_arrow_right.svg')}
                      alt="Registrate al programa"
                    />
                  </div>
                </button>
              </div>
            </div>
          </div>
        ))}
    </Slider>
  )
};

export default SliderInfo;
